export default "__VITE_ASSET__g4OW3qsh__"